import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_API_URL.replace("/api", "");

const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ["websocket"]
});

export default socket;